export const createPath = (editionEndpoint: string) => (path: any) => {
  return `https://${editionEndpoint}${path}`;
};
